<template>
  <div class="lens-combo-pro">
    <div class="viz-header-compact" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula-chip" v-latex>$1/f_total = 1/f1 + 1/f2 - d/(f1·f2)$</div>
    </div>

    <div class="main-layout vertical">
      <!-- 仿真区域 -->
      <div class="simulation-stage dark-stage">
        <svg width="100%" height="220" viewBox="0 0 400 220">
          <!-- 光轴 -->
          <line x1="20" y1="110" x2="380" y2="110" stroke="rgba(255,255,255,0.15)" stroke-width="1.5" stroke-dasharray="4,2" />
          
          <!-- Lenses -->
          <g transform="translate(100, 110)">
            <ellipse rx="8" ry="45" fill="rgba(6, 182, 212, 0.2)" stroke="#22d3ee" stroke-width="2" />
            <text x="0" y="-55" text-anchor="middle" fill="#22d3ee" font-size="10" font-weight="700">L1 (50mm)</text>
          </g>
          <g :transform="`translate(${100 + spacing}, 110)`">
            <ellipse rx="8" ry="45" fill="rgba(6, 182, 212, 0.2)" stroke="#22d3ee" stroke-width="2" />
            <text x="0" y="-55" text-anchor="middle" fill="#22d3ee" font-size="10" font-weight="700">L2 (50mm)</text>
          </g>

          <!-- Light Rays -->
          <path :d="rayPath" fill="none" stroke="#f59e0b" stroke-width="2" opacity="0.8" />
          
          <!-- Distance Labels -->
          <line :x1="100" y1="170" :x2="100 + spacing" y2="170" stroke="#94a3b8" stroke-width="1" marker-start="url(#dot)" marker-end="url(#dot)" />
          <text :x="100 + spacing/2" y="185" text-anchor="middle" fill="#94a3b8" font-size="10" font-weight="700">间距 d = {{ spacing }}mm</text>

          <defs>
             <marker id="dot" markerWidth="4" markerHeight="4" refX="2" refY="2"><circle cx="2" cy="2" r="2" fill="#94a3b8" /></marker>
          </defs>
        </svg>

        <div class="hud-panel">
           <div class="hud-item cyan">
              <label>系统总焦距 (f_total)</label>
              <span class="val">{{ totalFocalLength.toFixed(1) }} <small>mm</small></span>
           </div>
        </div>
      </div>

      <!-- 控制面板 -->
      <div class="compact-controls">
        <div class="control-card">
           <div class="s-item">
              <label>调节透镜间距 d (变焦控制)</label>
              <el-slider v-model="spacing" :min="30" :max="150" size="small"></el-slider>
           </div>
        </div>

        <div class="discovery-card-compact" v-latex>
           <i class="el-icon-info"></i>
           <p><strong>变焦原理：</strong>通过改变两个透镜之间的距离 $d$，可以平滑调整系统的总焦距。这是单反镜头和望远镜实现变焦（Zoom）的核心物理基础。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LensesCombinationViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      spacing: 80,
      f1: 50,
      f2: 50
    }
  },
  computed: {
    totalFocalLength() {
      let val = (1/this.f1) + (1/this.f2) - (this.spacing / (this.f1 * this.f2));
      return 1 / (val || 0.0001);
    },
    rayPath() {
      let y0 = 90;
      let x1 = 100;
      let y1 = y0;
      let slope1 = (y1 - 110) / this.f1;
      let x2 = 100 + this.spacing;
      let y2 = y1 - slope1 * this.spacing;
      let slope2 = slope1 + (y2 - 110) / this.f2;
      let x3 = 380;
      let y3 = y2 - slope2 * (x3 - x2);
      return `M 20 ${y0} L ${x1} ${y1} L ${x2} ${y2} L ${x3} ${y3}`;
    }
  }
}
</script>

<style scoped lang="scss">
.lens-combo-pro { flex: 1; display: flex; flex-direction: column; gap: 8px; height: 100%; overflow: hidden; }
.viz-header-compact { display: flex; justify-content: space-between; align-items: center; padding: 0 4px; .brief { font-size: 13px; color: #1e293b; font-weight: 500; } .formula-chip { background: #f0f7ff; color: #2563eb; border: 1px solid #dbeafe; padding: 4px 14px; border-radius: 20px; font-weight: 700; font-family: monospace; } }
.simulation-stage { flex: 1; min-height: 220px; background: #020617; border-radius: 12px; border: 1.5px solid #1e293b; position: relative; overflow: hidden; .hud-panel { position: absolute; top: 12px; left: 12px; z-index: 10; .hud-item { background: rgba(15, 23, 42, 0.82); border-radius: 8px; border: 1px solid #1e293b; padding: 4px 12px; label { display: block; font-size: 10px; color: #64748b; font-weight: 700; } .val { font-size: 14px; color: #22d3ee; font-weight: 800; small { font-size: 10px; opacity: 0.6; } } &.cyan { border-left: 3px solid #06b6d4; } } } }
.compact-controls { display: flex; flex-direction: column; gap: 8px; }
.control-card { background: #ffffff; padding: 12px 16px; border-radius: 12px; border: 1px solid #e2e8f0; }
.s-item { label { font-size: 12px; color: #64748b; font-weight: 700; display: block; margin-bottom: 2px; } }
.discovery-card-compact { background: #f0f9ff; padding: 10px 14px; border-radius: 10px; border: 1px solid #e0f2fe; display: flex; align-items: center; gap: 10px; i { color: #0ea5e9; font-size: 1.1rem; } p { flex: 1; margin: 0; font-size: 12px; color: #0369a1; line-height: 1.5; strong { color: #075985; } } }
</style>
